import http, {RequestOptions, noContent, unwrap} from "@/api/http";
import {CollectionDto, CollectionInventoryInput} from "@/api/types";

export interface ListCollectionsParams {
    /** Required for an admin (400 without it); for everyone else the server uses their own partner. */
    partnerId?: number;
}

/** `GET /api/collections?partnerId=` (#20, P) */
export const listCollections = (params: ListCollectionsParams = {}, options?: RequestOptions): Promise<CollectionDto[]> =>
    http.get<CollectionDto[]>("/collections", {...options, params}).then(unwrap);

/** `PUT /api/collections/{id}/inventory` (#21, owner or admin). 204; 404 if unknown, 403 if not the caller's collection. */
export const updateCollectionInventory = (id: number, input: CollectionInventoryInput, options?: RequestOptions): Promise<void> =>
    http.put(`/collections/${id}/inventory`, input, options).then(noContent);
